enum CreditCardProviderEnum {
  AmericanExpress = 'american-express',
  Discover = 'discover',
  Mastercard = 'mastercard',
  Visa = 'visa',
}

export default CreditCardProviderEnum;
